import { render, staticRenderFns } from "./CoralsolManejosForm.vue?vue&type=template&id=56b3e619&scoped=true&"
import script from "./CoralsolManejosForm.vue?vue&type=script&lang=js&"
export * from "./CoralsolManejosForm.vue?vue&type=script&lang=js&"
import style0 from "./CoralsolManejosForm.vue?vue&type=style&index=0&id=56b3e619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3e619",
  null
  
)

export default component.exports